import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { ReportController } from 'src/controllers/report.controller'
import { ProcessReportDto } from 'src/dto/report.dto'

const reportController = new ReportController()

export function useProcessReport() {
  return useMutation({
    mutationFn: (processReportDto: ProcessReportDto) =>
      reportController.processReport(processReportDto.idFazenda, processReportDto),
    onError: () => {
      toast.error('Erro ao processar relatório')
    }
  })
}
